import React, {useState} from 'react';
import {inject, observer} from 'mobx-react';
import {RouteComponentProps} from 'react-router-dom';
import {UserStoreTypes} from '@/stores/user';
import {View, Input, Button, Typography} from '@/components';
import { CodeInput } from '@/components/Input'
import {Row, Col, message} from 'antd'
import {useEffectOnce, useLocalStorage} from 'react-use';
import {checkListEnum, createCheckIterator, run} from '@/utils/RegExps';
import Encryption from '@/utils/Encryption';
import { checkPassword } from '@/utils/RegExps';
import log from '@/utils/log';

export interface PropsType {
    UserStore: UserStoreTypes;
}

type SignInProps = PropsType & RouteComponentProps;

export const Modify: React.FC<SignInProps> = inject('UserStore')(observer(props => {
  
    const {ModifyStore} = props.UserStore.AccountStore;
  
    const [password, setPassword] = useState('')
  
    const [userInfo]: any = useLocalStorage('userInfo');
  
    const handleInputOnChange = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
        ModifyStore.setUserAccount({[key]: e.target.value})
    }
  
    const handleModifyOnClick = async () => {
        const checkList = [checkListEnum.mobile, checkListEnum.code,checkListEnum.password,]
        const status = createCheckIterator(checkList, ModifyStore.userAccount)
        const result= run(status, checkList);
        if (!result.done) return;
        if (!checkPassword(ModifyStore.userAccount.password)) {
            message.error('密码有误')
            return
        }
        ModifyStore.setUserAccount({
            newPassword: password
        })
        await ModifyStore.modify()
    }
  
    useEffectOnce(() => {
      log({pageId: 'P20',eventId: 'E2000', ext: ''})
      if(typeof userInfo === 'object') {
            const {mobile,token} = userInfo
            const uid = JSON.parse(Encryption.decayFun(token, 'NgAbCJJGfUlQ6653')).uid
            ModifyStore.setUserAccount({
                mobile: mobile,
                uid ,
            })
        }
    })
  
    return (
    <>
      <Typography.Title level={1}>修改密码</Typography.Title>
      <Row gutter={[16, 16]}>
          <Col><Input disabled value={ModifyStore.userAccount.mobile} size='large' placeholder='请输入您的手机号' /></Col>
          <Col><CodeInput value={ModifyStore.userAccount.code} onChange={(e) => handleInputOnChange(e,'code')}  phone={ModifyStore.userAccount.mobile} size='large' type={5}  placeholder='请输入验证码' /></Col>
          <Col><Input value={ModifyStore.userAccount.password} onChange={(e) => handleInputOnChange(e,'password')} size='large' type='password' placeholder='请输入密码' /></Col>
          <Col><Input value={password} onChange={(e) => setPassword(e.target.value)} size='large' type='password' placeholder='请输入密码' /></Col>
          <Col><Button onClick={handleModifyOnClick} type="primary" size='xl' block>确定</Button></Col>
      </Row>
    </>
    )
  
}))

export default View.Center(Modify);
